import { render, staticRenderFns } from "./TableRefereeTypeEvents.vue?vue&type=template&id=5a6f9834&scoped=true&"
import script from "./TableRefereeTypeEvents.vue?vue&type=script&lang=js&"
export * from "./TableRefereeTypeEvents.vue?vue&type=script&lang=js&"
import style0 from "./TableRefereeTypeEvents.vue?vue&type=style&index=0&lang=css&"
import style1 from "./TableRefereeTypeEvents.vue?vue&type=style&index=1&id=5a6f9834&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a6f9834",
  null
  
)

export default component.exports